import { render, staticRenderFns } from "./adminInspectionTaskDetailList.vue?vue&type=template&id=08dc5589&scoped=true"
import script from "./adminInspectionTaskDetailList.vue?vue&type=script&lang=js"
export * from "./adminInspectionTaskDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminInspectionTaskDetailList.vue?vue&type=style&index=0&id=08dc5589&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc5589",
  null
  
)

export default component.exports